/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface CRSFSecReviewHoneypots
 */
export interface CRSFSecReviewHoneypots {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewHoneypots
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypots
     */
    found: number;
    /**
     * 
     * @type {Port}
     * @memberof CRSFSecReviewHoneypots
     */
    port: Port;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewHoneypots
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewHoneypots
     */
    source_asset?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewHoneypots
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypots
     */
    updated: number;
}

/**
 * Check if a given object implements the CRSFSecReviewHoneypots interface.
 */
export function instanceOfCRSFSecReviewHoneypots(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function CRSFSecReviewHoneypotsFromJSON(json: any): CRSFSecReviewHoneypots {
    return CRSFSecReviewHoneypotsFromJSONTyped(json, false);
}

export function CRSFSecReviewHoneypotsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewHoneypots {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'found': json['found'],
        'port': PortFromJSON(json['port']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'updated': json['updated'],
    };
}

export function CRSFSecReviewHoneypotsToJSON(value?: CRSFSecReviewHoneypots | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'found': value.found,
        'port': PortToJSON(value.port),
        'shared': value.shared,
        'source_asset': value.source_asset,
        'tags': value.tags,
        'updated': value.updated,
    };
}

